import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.#markDirection() // Default state
        document.addEventListener("turbo:visit", this.#markDirection)
        window.addEventListener("popstate", this.#markBack)
    }

    disconnect() {
        document.removeEventListener("turbo:visit", this.#markDirection)
        window.removeEventListener("popstate", this.#markBack)
    }

    #markDirection = () => {
        document.documentElement.dataset.turboVisitDirection = "forward"
    }

    #markBack = () => {
        document.documentElement.dataset.turboVisitDirection = "back"
    }
}
